module.exports = __webpack_public_path__ + "static/media/snare.134b3bc5.wav";